<div class="container-fluid">
  <div class="row info-modal-header">
    <div class="col-9 modal-header-title">
      <h1 mat-dialog-title class="title">{{data.tableName}}</h1>
    </div>
    <div class="col-3">
      <button mat-button (click)="closeModal()"><i class="fa fa-window-close fa-lg"></i></button>
    </div>
  </div>
  <mat-dialog-content class="mb-4" [innerHTML]="data.info"></mat-dialog-content>
  <mat-dialog-content *ngIf="disclaimerExists">
    <h6><strong>DISCLAIMER CEDLAB</strong></h6>
    <div [innerHTML]="disclaimer"></div>
  </mat-dialog-content>
</div>
